// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3pbQ7","bottomCard":"card_bottomCard__6Gmxk","mesa":"card_mesa__1cz3S","icon":"card_icon__1CjYM"};